import { Box } from "@mui/material"
import React from "react"
import { Col, Row } from "react-bootstrap"
import AppTextField from "components/StyledComponents/AppTextField"

const HistoryFormHotel = ({ formik }) => {
  return (
    <div>
      <Box flexDirection="column">
        <Row className="w-100 m-0 mt-4 mb-4">
          <Col lg="12">
            <AppTextField
              id={`heading`}
              name={`heading`}
              label="Heading"
              isUpperCase={true}
              type="text"
              fullWidth
              placeholder={`Enter Heading`}
              value={formik.values.item_history?.heading || ""}
              onChange={(event) => {
                formik.setFieldValue(`item_history.heading`, event.target.value)
              }}
              onBlur={formik.handleBlur(`heading`)}
              error={Boolean(formik.errors?.item_history?.heading)}
              helperText={formik.errors?.item_history?.heading}
            />
          </Col>
          <Col lg="12" className="mt-4">
            <AppTextField
              id={`content`}
              name={`content`}
              label="Content"
              isUpperCase={true}
              type="text"
              fullWidth
              placeholder={`Enter Content`}
              value={formik.values.item_history?.content || ""}
              onChange={(event) => {
                formik.setFieldValue(`item_history.content`, event.target.value)
              }}
              onBlur={formik.handleBlur(`content`)}
              error={Boolean(formik.errors?.item_history?.content)}
              helperText={formik.errors?.item_history?.content}
            />
          </Col>
        </Row>
      </Box>
    </div>
  )
}

export default HistoryFormHotel
